/**
 * getRequestParams
 *
 * Генерируем строку GET-запроса (query string) из объекта payload
 *
 * @param {Object}  payload - объект с параметрами
 * @param {Array}   exclude - массив имён параметров, которые не попадут в query string
 *
 * @returns {String} Строка запроса
 */
export default function getRequestParams(payload, exclude) {
    let params = ''
    if (payload) {
        for (let param in payload) {
            if (!param.includes(exclude)) {
                if (Array.isArray(payload[param])) {
                    payload[param].map(el => {
                        params.length ? (params += '&' + param + '=' + el) : (params = '?' + param + '=' + el)
                    })
                } else {
                    if (!param.includes(exclude)) {
                        params.length
                            ? (params += '&' + param + '=' + payload[param])
                            : (params = '?' + param + '=' + payload[param])
                    }
                }
            }
        }
    }
    return params
}
